import { MessagePayload, WhatsappTemplateData } from '@zonofi/common';
import { CustomerSearchResponse } from '../customers';
import { IssueRole } from '../thread';
import { OrderImportSourceEnum } from '../utils/helpers/enum';

export interface AddChannelMemberRequest {
  userId: string;
  workspaceId: string;
  channelId: string;
  customerIds?: string[];
  members?: { id: string; role?: string; issueRole?: IssueRole }[];
  inviteId: string | undefined;
  sellerWorkspaceId: string;
  employeeName?: string;
  numOfMember?: number;
  showToast?: boolean;
  isIssueRoleChange?: boolean;
}

export interface AddChannelMemberNonPlatformRequest {
  nonPlatformMemberId: string;
  sellerWorkspaceId: string;
  payload: {
    channelId: string;
    teamMemberId?: string;
    customerId?: string;
    userId?: string;
  };
}

export interface RemoveChannelMemberRequest {
  userId: string;
  workspaceId: string;
  channelId: string;
  customerIds?: string[];
  memberIds?: string[];
  inviteId: string | undefined;
  sellerWorkspaceId: string;
  employeeName?: string;
  showToast?: boolean;
}

export interface CreateChannelRequest {
  channelName: string;
  workspaceId: string;
  inviteId: string;
  emojiId?: string;
  folderId?: string;
  id?: string;
  sellerWorkspaceId: string;
}

export interface Channel {
  id: string;
  createdAt: string;
  updatedAt: string;
  channelName: string;
  linkedWorkspaceId: string;
  accessType: string;
  profilePic?: string;
  updatedBy?: null;
  workspaceId: string;
  description: string;
  ownerId?: null;
  appId: string;
  type: string;
  customerId?: string;
  folderId: string;
  emojiId: string;
  channelMembers?: ChannelMembers;
  lastMessageTimeToken?: number;
  unReadMessagesCount?: number;
  role?: ChannelMemberRole;
  channelSubType?: string;
}

export type ChannelMemberRole = 'ADMIN' | 'MEMBER' | 'CUSTOMERADMIN' | null;

export interface ChannelMembers {
  customers: ChannelCustomer[];
  teamMembers: ChannelTeamMember[];
}

export interface ChannelListRequest {
  workspaceId: string;
  inviteId?: string;
  principalWorkspaceId?: string;
  sellerWorkspaceId: string;
  random?: number;
}

export interface ChannelListResponse {
  folders: Folder[];
  rootChannels: Channel[];
}

export interface Folder {
  id: string;
  createdAt: null;
  updatedAt: null;
  name: string;
  parentId: string | null;
  workspaceId: string;
  colorCode: string;
  shadeVariation: string;
  channels?: Channel[];
  subFolders?: Folder[];
}

export interface StoredFolder {
  id: string;
  createdAt: null;
  updatedAt: null;
  name: string;
  parentId: string | null;
  workspaceId: string;
  colorCode: string;
  shadeVariation: string;
  channels?: string[];
  subFolders?: StoredFolder[];
}

export interface ChannelDetailsRequest {
  workspaceId: string;
  channelId?: string;
  sellerWorkspaceId: string;
  customerId?: string;
  channelType?: string;
  random?: number;
}

export interface AcceptChannelInviteRequest {
  workspaceId: string;
  channelId: string;
  principalWorkspaceId?: string;
  inviteId: string;
  sellerWorkspaceId: string;
}

export interface GetChannelNameRequest {
  workspaceId: string;
  channelId: string;
  // principalWorkspaceId?: string;
  inviteId: string;
  sellerWorkspaceId: string;
}

export interface CompanyTeamMember {
  cityName: string;
  companyName: string;
  employeeCode: string;
  employeeName: string;
  fulfillmentLocationId: string;
  inviteId: string;
  stateName: string;
  role: string;
}

export enum OrderAction {
  orderToBeApproved = 'Orders To Be Approved',
  toBeInvoiced = 'To Be Invoiced',
  sendPaymentRequest = 'Send Payment Request',
  paymentReceived = 'Payment Received',
}

export enum Enquiry {
  priceEnquiry = 'Price Enquiry',
  invoiceEnquiry = 'Invoice Enquiry',
  schemsEnquiry = 'Schemes Enquiry',
  orderEnquiry = 'Order Enquiry',
  ledgerEnquiry = 'Ledger Enquiry',
  paymentEnquiry = 'Payment Enquiry',
}

export enum IssueTransactionType {
  DISPATCH = 'dispatch',
  ORDER = 'order',
  INVOICE = 'invoice',
  PAYMENT = 'payment',
  UNKNOWN = 'unknown',
}

export interface ChannelDetails {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  channelName: string;
  linkedWorkspaceId?: string;
  accessType?: string;
  profilePic?: string;
  updatedBy?: null;
  emojiId?: string;
  description?: string;
  ownerId?: string | null;
  isDefault?: boolean;
  appId?: string;
  channelType?: string;
  channelSubType?: string;
  customerId?: string;
  customerName?: string;
  companyName?: string;
  transactionType?: IssueTransactionType;
  channelRole?: string;
  workspaceId?: string;
  folderId?: string;
  role?: ChannelMemberRole;
  customers?: ChannelCustomer[];
  teamMembers?: ChannelTeamMember[];
  companyTeamMembers?: CompanyTeamMembers[];
  latestMessage?: string;
  latestMessageTimeToken?: string;
  latestTransactionMessage?: string;
  type: string;
  isActive?: boolean;
  latestWaMessageTimeToken?: string;
  status?: boolean;
  sellerWorkspaceId?: string;
  action?: string;
  unreadCount?: number;
  isLockedCustomer?: boolean;
  customerInfo?: CustomerSearchResponse;
  customerIsLoading?: boolean;
  totalMessageCount?: number;
  issueStatus?: string;
  phoneNumber?: string;
  threadTags?: ThreadTagListItem[];
  marketingMessageLimitExhausted?: boolean;
  optedOut?: boolean;
  customerCode?: string;
  lastVisitedTimeToken: string;
  beatPlanScheduleCustomerId?: string;
  beatPlanScheduleRouteId?: string;
  nonPlatformMembers?: NonPlatformMembers[];
  contacts?: GroupContact[];
  waProvider?: string;
  conversationTags?: ThreadTagListItem[];
}

export interface ThreadTagListItem {
  text: string;
  color: string;
  backgroundColor: string;
  icon?: string;
  isMarginTop?: boolean;
  isMarginBottom?: boolean;
}

export interface CustomerTeam {
  createdDate: string;
  employeeName: string | null;
  id: string;
  inviteType: string;
  invitedUserId: string;
  invitedWorkspaceId: string;
  isActive: number;
  isArchive: number;
  phone: string;
  phone2: string | null;
  role: string;
  senderUserId: string;
  senderWorkspaceId: string;
  status: string;
  updatedDate: string;
  userType: string | null;
  phoneNumber?: string;
}

export interface ChannelCustomer {
  name?: string;
  inviteId: string;
  distributorCode?: string;
  companyName?: string;
  stateName?: string;
  cityName?: null;
  phone?: string;
  employeeName?: string;
  team?: CustomerTeam[];
  phoneNumber?: string;
}

export interface ChannelTeamMember {
  teamMemberRole?: any;
  id?: string;
  inviteId: string;
  employeeCode?: string;
  employeeName?: string;
  cityName?: null | string;
  stateName?: null | string;
  isActive?: boolean;
  mobile?: string;
  role?: 'MEMBER' | 'ADMIN' | 'CUSTOMERADMIN' | any;
  userId?: string;
  phone?: string;
  issueRole?: IssueRole;
  companyName?: string;
  userType?: string;
  phoneNumber?: string;
}

export interface CompanyTeamMembers {
  cityName: string;
  companyName: string;
  employeeCode: string;
  employeeName: string;
  fulfillmentLocationId: string;
  inviteId: string;
  stateName: string;
  role?: string;
  phoneNumber?: string;
  userId?: string;
}

export interface NonPlatformMembers {
  id: string;
  waMemberId: string;
  phone: string;
  phoneNumber: string;
  displayName: string;
  userId: string;
  role: string;
  issueRole: IssueRole;
  customerId: string;
  teamMemberId: string;
  userType: any;
  avatar: any;
}
export interface GroupContact {
  inviteId: string;
  profileName: string;
  displayName: string;
  email: string;
  mobile: string;
  id: string;
}

export interface MoveChannelRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  body: {
    channelIds: string[];
    folderId: string;
  };
}

export interface LeaveChannelRequest {
  workspaceId: string;
  channelId: string;
  inviteId: string;
  principalWorkspaceId?: string;
  sellerWorkspaceId: string;
}

export interface DeleteChannelV2Request {
  type?: string;
  workspaceId: string;
  channelId: string;
  inviteId: string;
  sellerWorkspaceId: string;
}

export interface GetWhatsappTemplateRequest {
  sellerWorkspaceId: string;
  name: string;
}
interface Card {
  components: {
    type: string;
    text: string;
    example?: {
      body_text: string[][];
      header_handle: string[];
    };
  }[];
}

export interface TemplateComponent {
  format: string;
  type: string;
  text: string;
  example?: {
    body_text: string[][];
    header_handle?: string[];
  };
  url?: string;
  cards?: { components: TemplateComponent[] }[];
  buttons?: TemplateComponent[];
}

export interface GetWhatsappTemplateResponse {
  code: number;
  error_data: any;
  status: string;
  data: WhatsappTemplateData;
}

export interface GetCampaignCustomTemplatesRequest {
  sellerWorkspaceId: string;
  searchName?: string;
}

export interface LogZoAIActionsRequest {
  body: LogZoAIActionsRequestBody;
  userId: string;
}

interface LogZoAIActionsRequestBody {
  action: 'start' | 'end' | 'accept';
  entityName: 'order' | 'invoice';
  entityIds?: number[] | string[];
}

export interface PublishMessagePayload {
  sellerWorkspaceId: string;
  conversationId?: string;
  channelId?: string;
  inviteIds?: string[];
  message: MessagePayload;
  isInternalNote?: boolean;
}

export interface PublishMessageToBotPayload {
  object: string;
  entry: {
    id: string;
    changes: {
      field: string;
      value: {
        messaging_product: string;
        metadata: {
          display_phone_number: string;
          phone_number_id: string;
        };
        contacts?: {
          profile: {
            name: string;
          };
          wa_id: string;
        }[];
        messages?: {
          from: string;
          id: string;
          timestamp: string;
          text?: {
            body: string;
          };
          type: string;
        }[];
      };
    }[];
  }[];
}

export interface PublishMessageToBotPayload {
  object: string;
  entry: {
    id: string;
    changes: {
      field: string;
      value: {
        messaging_product: string;
        metadata: {
          display_phone_number: string;
          phone_number_id: string;
        };
        contacts?: {
          profile: {
            name: string;
          };
          wa_id: string;
        }[];
        messages?: {
          from: string;
          id: string;
          timestamp: string;
          text?: {
            body: string;
          };
          type: string;
        }[];
      };
    }[];
  }[];
}

export interface PreviewWhatsAppSyncRequest {
  sellerWorkspaceId: string;
}
export interface PreviewWhatsAppSyncResponse {
  groups: PreviewWhatsAppSyncGroup[];
}

export interface PreviewWhatsAppSyncGroup {
  name: string;
  isNew: boolean;
  customers: {
    name: string;
    mobileNumber: string;
  }[];
}

export interface PreviewWhatsAppSyncCustomer {
  title: string;
  mobileNumber: string;
  status: string;
  type?: string;
  subTitle?: string;
}

export interface CheckWhatsAppSyncStatusRequest {
  groupName: string;
  sellerWorkspaceId: string;
  members?: PreviewWhatsAppSyncMember[];
  sellerPhoneNumber?: string;
  sellerName?: string;
}
export interface CheckWhatsAppSyncStatusResponse {
  groupName: string;
  sellerWorkspaceId: string;
  members: CheckWhatsAppSyncStatusResponseMember[];
}

export interface CheckWhatsAppSyncStatusResponseMember {
  mobile: string;
  status: string;
  type?: string;
  companyName?: string;
  employeeName?: string;
  name?: string;
}

export interface PreviewWhatsAppSyncMember {
  mobile: string;
  name: string;
}

export enum ChannelTypeEnum {
  APP = 'app',
  PRINCIPAL = 'principal',
  CUSTOMER = 'customer',
  THREAD = 'TH',
  CUSTOMERTHREAD = 'THC',
  ISSUETHREAD = 'THT',
  GROUPTHREAD = 'THG',
  ZOAI = 'zo.ai',
}

export type ThreadTypeEnum =
  | ChannelTypeEnum.CUSTOMERTHREAD
  | ChannelTypeEnum.ISSUETHREAD
  | ChannelTypeEnum.GROUPTHREAD;

export enum RemoveThreadAction {
  MAKEADMIN = 'MakeAdmin',
  ADMIN = 'admin',
  CUSTOMERADMIN = 'customeradmin',
  MAIN = 'main',
  CUSTOMER = 'customer',
  TeamMEMBER = 'teamMember',
  MEMBER = 'member',
}

export interface ChannelThread {
  id: string;
  name: string;
}

export interface CommonThreadsResponse {
  channels: ChannelThread[];
}

export interface CommonThreadsRequest {
  customerInviteId?: string;
  sellerWorkspaceId: string;
  userInviteId: string;
  teamMemberInviteId?: string;
}

export interface ParseFileBody {
  fileName: string;
  mimeType: string;
  url: string;
  extension: string;
}

export interface ParseFileRequest {
  sellerWorkspaceId: string;
  body: ParseFileBody;
}

export interface SendCampaignRequest {
  body: any;
  sellerWorkspaceId: string;
}
export interface GenerateShortUrlRequest {
  body: { type: string; url: string };
  sellerWorkspaceId: string;
}

export interface SendCampaignResponse {}

export type PublishToBotRes = string | OrderIntentResponse | void;

export interface OrderIntentResponse {
  isParsed: boolean;
  poNumber: string;
  parsedFileName: any;
  originalFileName: any;
  status: string;
  dateTimeOfImport: string;
  importSource: OrderImportSourceEnum;
  parsedOutput: string;
  mappedOutput: string;
  channelId: number;
  userId: string;
  userType: string;
  customerId: string;
  waMessage: string;
  poDate: any;
  teamMemberId: any;
  fileType: any;
  erpCode: any;
  parsingStartTime: any;
  parsingEndTime: any;
  mappingStartTime: any;
  mappingEndTime: any;
  isMapped: any;
  freshdeskTicketId: any;
  ticketResolutionTime: any;
  id: string;
  createdDate: string;
  updatedDate: string;
  isArchived: boolean;
  isFileParsed: boolean;
  isMapOrder: boolean;
  totalLineItems: number;
  totalQuantity: any;
  discount: any;
  totalWithTax: any;
  total: any;
  notifyToBuyer: boolean;
}

export interface ChannelByFolderRequest {
  sellerWorkspaceId: string;
  folderType: string;
}

export interface ChannelByFolder {
  channelId: string;
  channelName: string;
  customers: number;
}

export interface ListMessageBotsRequest {
  id?: string;
  sellerWorkspaceId: string;
  version?: string;
  createdAfter?: Date;
  createdBefore?: Date;
  updatedAfter?: Date;
  updatedBefore?: Date;
  name?: string;
  folderId?: string;
  selectedThemeTemplateId?: string;
  publicId?: string;
  customDomain?: string;
  workspaceId?: string;
  whatsAppCredentialsId?: string;
  riskLevel?: number;
  intent?: string;
  isArchived?: boolean;
  includeAdditionalSettings?: boolean;
  isClosed?: boolean;
  search?: string;
  tags?: string[];
  take?: number;
  skip?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
  includeAnalytics?: boolean;
  timeFilter?: 'last24h' | 'last7Days' | 'last30Days' | 'last90Days';
  includeScheduleOptions?: boolean;
  isPlatForm?: boolean;
  isTemplate?: boolean;
}

export interface ScheduleOptions {
  occurrence: 'one-off' | 'recurring';
  startDate: string;
  endDate: string;
  recurringType?: 'rate' | 'cron';
  repeatFrequency?: number;
  repeatType?: RateUnit;
  date?: string;
  time?: string;
  weekDays?: string;
  triggerOnDay?: string;
}
export interface ListMessageBotsResponse {
  data: ListMessageBotsData[];
  meta: {
    total: number;
    skip: number;
    take: number;
  };
}
export interface CloneMessageBotsResponse {
  message: string;
  bot: {
    id: string;
    version: string;
    createdAt: string;
    updatedAt: string;
    icon: string;
    name: string;
    description: string | null;
    folderId: string | null;

    groups: {
      id: string;
      title: string;
      blocks: {
        id: string;
        type: string;
        options: {
          action?: string;
          variableId?: string;
        };
        outgoingEdgeId?: string;
      }[];
      graphCoordinates: {
        x: number;
        y: number;
      };
    }[];

    events: {
      id: string;
      type: string;
      outgoingEdgeId: string;
      graphCoordinates: {
        x: number;
        y: number;
      };
    }[];

    variables: {
      id: string;
      name: string;
      isSessionVariable?: boolean;
    }[];

    edges: {
      id: string;
      to: {
        groupId: string;
      };
      from: {
        eventId?: string;
        blockId?: string;
      };
    }[];

    tags: string[];

    theme: Record<string, unknown>;
    selectedThemeTemplateId: string | null;

    settings: {
      general: {
        isBrandingEnabled: boolean;
      };
      errorMessageBlock: {
        id: string;
        type: string;
        options: {
          message: {
            text: {
              body: {
                en: string;
                hi: string;
              };
              preview_url: boolean;
            };
            type: string;
          };
          endSession: boolean;
          shouldSkip: boolean;
          dynamicTemplate: boolean;
          retryMessageContent: {
            en: string;
            hi: string;
          };
        };
      };
    };

    publicId: string | null;
    customDomain: string | null;
    workspaceId: string;

    resultsTablePreferences: unknown | null;

    isArchived: boolean;
    isClosed: boolean;
    isPlatForm: boolean;

    whatsAppCredentialsId: string | null;
    riskLevel: string | null;
    intent: string | null;
    code: string | null;

    userType: string;
  };
  additionalSettingsCopied: number;
}

export interface ListMessageBotsData {
  id: string;
  version: string;
  createdAt: string;
  updatedAt: string;
  icon: any;
  name: string;
  code?: string;
  folderId: any;
  publicId?: string;
  description?: string;
  workspaceId: string;
  isArchived: boolean;
  isClosed: boolean;
  intent?: string;
  isPlatForm: boolean;
  additionalSettings: AdditionalSetting[];
  settings: MessageBotSettings;
  analytics: {
    totalSessions: number;
    completedSessions: number;
    completionRate: number;
    droppedSessions: number;
    dropRate: number;
    timeFilter: string;
  };
  scheduleOptions?: ScheduleOptions;
  tags?: string[];
}

export interface MessageBotSettings {
  general: {
    isBrandingEnabled: boolean;
  };
  whatsApp: {
    isEnabled: boolean;
    startCondition: {
      comparisons: DefaultBotSettingsOptionInfo[];
      logicalOperator: DefaultBotOperatorEnum;
    };
    sessionExpiryTimeout: number;
    startConditionDescription?: string;
    audience: {
      operator: DefaultBotOperatorEnum;
      segments: { id: string; name: string }[];
      channels: { id: string; name: string }[];
      customers: {
        id: string;
        name: string;
        phoneNumber: string;
        distributorCode: string;
      }[];
    };
  };
}
export interface AdditionalSetting {
  waConfigId: string;
  settings: Settings;
}

export interface Settings {
  type: string;
  agentSettings?: {
    enableB2COrderAgent?: boolean;
  };
  menuOptions: MenuOption[];
  welcomeMessage: WelcomeMessage;
  salesParentMenuOptions?: MenuOption[];
  salesCheckInMenuOptions?: MenuOption[];
}

export interface MenuOption {
  id: string;
  title: {
    en: string;
    hi: string;
  };
  description: {
    en: string;
    hi: string;
  };
  name?: string;
  formId?: string;
}

export interface WelcomeMessage {
  en: string;
  hi: string;
}

export interface UpdateMessageBotSettingRequest {
  id: string;
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    name?: string;
    intent?: string;
    code?: string;
    settings?: {
      whatsApp?: {
        isEnabled?: boolean;
        sessionExpiryTimeout?: number;
        startCondition?: {
          logicalOperator: string | null;
          comparisons: DefaultBotSettingsOptionInfo[];
        };
        audience?: {
          operator: DefaultBotOperatorEnum;
          segments?: { id: string; name: string }[];
          channels?: { id: string; name: string }[];
          customers?: {
            id: string;
            name: string;
            phoneNumber: string;
            distributorCode: string;
          }[];
        };
      };
      general?: {
        theme: string;
        defaultLanguage: string;
      };
    };
    additionalSettings?: {
      waConfigId?: string;
      type?: string;
      settings?: {
        welcomeMessage?: {
          en?: string;
          hi?: string;
        };
        agentSettings?: {
          enableB2COrderAgent: boolean;
        };
        menuOptions?: {
          title: {
            en?: string;
            hi?: string;
          };
          description: {
            en?: string;
            hi?: string;
          };
        }[];
        salesParentMenuOptions?: {
          id: string;
          title: {
            en?: string;
            hi?: string;
          };
          description: {
            en?: string;
            hi?: string;
          };
          name?: string;
        }[];
        salesCheckInMenuOptions?: {
          id: string;
          title: {
            en?: string;
            hi?: string;
          };
          description: {
            en?: string;
            hi?: string;
          };
          name?: string;
        }[];
        salesParentFormId?: string;
        salesCheckInFormId?: string;
      };
    }[];

    scheduleOptions?: {
      occurrence: 'one-off' | 'recurring';
      recurringType?: 'rate' | 'cron';
      repeatFrequency?: number;
      repeatType?: RateUnit;
      startDate?: string;
      endDate?: string;
      date?: string;
      time?: string;
      weekDays?: string;
      triggerOnDay?: string;
    };
  };
}

export enum RateUnit {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
}
export interface BotSettingsOptionInfo {
  id: string;
  title: {
    en: string;
    hi: string;
  };
  description: {
    en: string;
    hi: string;
  };
}

export enum ComparisonOperators {
  EQUAL = 'Equal to',
  NOT_EQUAL = 'Not equal',
  CONTAINS = 'Contains',
  NOT_CONTAINS = 'Does not contain',
  GREATER = 'Greater than',
  LESS = 'Less than',
  IS_SET = 'Is set',
  IS_EMPTY = 'Is empty',
  STARTS_WITH = 'Starts with',
  ENDS_WITH = 'Ends with',
  MATCHES_REGEX = 'Matches regex',
  NOT_MATCH_REGEX = 'Does not match regex',
}
export enum DefaultBotOperatorEnum {
  AND = 'AND',
  OR = 'OR',
}
export interface DefaultBotSettingsOptionInfo {
  id: string;
  comparisonOperator: ComparisonOperators;
  value: string;
}

export interface DeleteMessageBotRequest {
  id: string;
  sellerWorkspaceId: string;
}

export interface GetDynamicSegmentsRequest {
  params: {
    sellerWorkspaceId: string;
    searchKey?: string;
    pageSize?: number;
    pageNo?: number;
    startDate?: string;
    endDate?: string;
  };
}

export const WeekDayTriggerOn = [
  {
    label: 'First',
    value: '1',
  },
  {
    label: 'Second',
    value: '2',
  },
  {
    label: 'Third',
    value: '3',
  },
  {
    label: 'Fourth',
    value: '4',
  },
  {
    label: 'Last',
    value: '4',
  },
];

export interface RedingtonMediaRequest {
  id: string;
  waConfigId: string;
  workspaceId: string;
}

export interface RootCustomerGroups {
  id: string;
  name: string;
  description: string;
  workspaceId: string;
  customerGroupType: string;
  parentId: string;
  customerCount: number;
  emojiId: string;
}

export interface SubFolders {
  id: string;
  name: string;
  customerGroups: RootCustomerGroups[];
  subFolders: SubFolders[];
}

export enum CustomerGroupTypeEnum {
  ROUTE = 'ROUTE',
  SEGMENT = 'SEGMENT',
}

export interface GetRoutesSegmentsResponse {
  folders: SubFolders[];
  rootCustomerGroups: RootCustomerGroups[];
}

export interface GetRoutesSegmentsRequest {
  params: {
    sellerWorkspaceId: string;
    customerGroupType: CustomerGroupTypeEnum;
  };
}

export interface WhatsappWebhookRequest {
  object: string;
  entry: Entry[];
}

interface Entry {
  id: string;
  changes: Change[];
}

interface Change {
  value: Value;
  field: string;
}

interface Value {
  messaging_product: string;
  metadata: Metadata;
  contacts: Contact[];
  messages: Message[];
}

interface Message {
  from: string;
  id: string;
  timestamp: string;
  text: Text;
  type: string;
  context: { id: string };
}

interface Text {
  body: string;
}

interface Contact {
  profile: Profile;
  wa_id: string;
}

interface Profile {
  name: string;
}

interface Metadata {
  display_phone_number: string;
  phone_number_id: string;
}

export interface SendWhatsappMessageResponse {
  message: string;
}

export interface SendWhatsappMessageRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    object: string;
    entry: {
      id: string;
      changes: {
        value: {
          messaging_product: string;
          metadata: {
            display_phone_number: string;
            phone_number_id: string;
            workspace_id: string;
          };
          contacts: {
            profile: {
              name: string;
            };
            wa_id: string;
          }[];
          messages: {
            from: string;
            id: string;
            timestamp: string;
            type: string;
            context?: {
              id?: string;
              text?: string;
            };
            reaction?: {
              message_id?: string;
              emoji?: string;
            };
            text?: {
              body?: string;
            };
            intent?: string;
          }[];
        };
        field: string;
      }[];
    }[];
  };
}

export interface GetBotResponsesRequest {
  params: {
    sellerWorkspaceId: string;
    workspaceId: string;
    cursor?: string;
    inviteIds?: string[];
    pageSize?: number;
  };
  id: string;
}

export interface GetBotResponsesExportRequest {
  params: {
    sellerWorkspaceId: string;
    workspaceId: string;
  };
  id: string;
}

export type GetBotResponsesExportResponse = Blob;
export interface GetBotResponsesResponse {
  data: {
    id: string;
    createdAt: string;
    typebotId: string;
    variables: {
      id: string;
      name: string;
      value: string;
      isSessionVariable: boolean;
    }[];
    metadata: {
      name: string;
      phone?: string;
    };
    isCompleted: boolean;
    hasStarted: boolean;
    isArchived: boolean;
    lastChatSessionId: any;
  }[];
  botName?: string;
  nextCursor?: string;
  previousCursors?: string[];
}

export interface GetTemplateVariablesRequest {
  templateName: string;
  sellerWorkspaceId: string;
}

export interface TemplateVariablesResponse {
  templateName: string;
  variableGroup: string;
  variables: Record<string, string>;
}

export interface GetOrderRequestPaymentTemplateResponse {}

export interface GetOrderRequestPaymentTemplate {
  entityName: string;
  eventType: string;
  userId: string;
  workspaceId: string;
  isUserEvent: boolean;
  cfaId: string;
  inviteId: string;
  sellerWorkspaceId: string;
  addInfo: any;
}
